(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-pro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
    console.error('jQuery or Slick Slider not loaded.');
    return;
  }

  function initVideoCarousel() {
    $('.video-carousel-slick').not('.slick-initialized').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 2500,
      prevArrow: `<button type="button" class="slick-prev">
                    <img src="https://cdn.shopify.com/s/files/1/0738/1994/7235/files/left-chevron_1.png?v=1761831147" alt="Previous">
                  </button>`,
      nextArrow: `<button type="button" class="slick-next">
                    <img src="https://cdn.shopify.com/s/files/1/0738/1994/7235/files/chevron_1.png?v=1761831147" alt="Next">
                  </button>`,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            arrows: false,
            dots: true,
            autoplay: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.2,
            arrows: false,
            dots: true,
            autoplay: true
          }
        }
      ]
    });
  }

  initVideoCarousel();

  // 🎬 Video play/pause on hover
  document.querySelectorAll('.video-card-media').forEach((video) => {
    video.pause();
    const card = video.closest('.video-card');
    card.addEventListener('mouseenter', () => video.play());
    card.addEventListener('mouseleave', () => video.pause());
  });

  // 🛒 Add to Cart with Redirect
  document.querySelectorAll('.add-to-cart-btn').forEach((button) => {
    button.addEventListener('click', function(e) {
      e.stopPropagation(); // prevent card click
      const variantId = this.dataset.variantId; 

      if (!variantId) {
        console.error('Variant ID missing for Add to Cart button');
        alert('Product variant not found!');
        return;
      }

      const formData = {
        id: variantId,
        quantity: 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to add to cart');
        return response.json();
      })
      .then(() => {
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Add to Cart Error:', error);
        alert('Something went wrong while adding the product.');
      });
    });
  });

  // 🖱️ Make entire video card clickable to product page
  document.querySelectorAll('.video-card-product-row').forEach((row) => {
    const productUrl = row.getAttribute('data-product-url');
    if (productUrl) {
      const card = row.closest('.video-card');
      card.style.cursor = 'pointer';
      card.addEventListener('click', (e) => {
        // prevent if clicked on "Add to Cart" button
        if (e.target.closest('.add-to-cart-btn')) return;
        window.location.href = productUrl;
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
